// extracted by mini-css-extract-plugin
module.exports =  {"adminBoardSettingsGeneral":"eeOv_Jmd","namingFields":"GQqN7bXp","description":"otpUjb03","row":"TcNg3glz","error":"iOxnWuHf","button":"jGHZrM4m"};